export default __webpack_public_path__ + "static/SectionTwo_01_02-8eb0b5e3b573e72abd118fded203ffa4.webp";